/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-const */
/* eslint-disable quote-props */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */
import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { DmsCreateJobcardResultValue, DmsService, DmsTask } from '../../../services/dms.service';
import { HelperService } from '../../../services/helper.service';
import { JSettings, SupaService } from '../../../services/supa.service';
import { VhcBrakeModule } from '../../../vhcmodules/brakemodule/vhcbrakemodule';
import { VhcQuestionblockModule } from '../../../vhcmodules/questionblock/vhcquestionblockmodule';
import { VhcTyreModule } from '../../../vhcmodules/tyremodule/vhctyremodule';
import { Vhcmodule } from '../../../vhcmodules/vhcmodule';
import { Part } from 'src/app/interfaces/part.interface';
import { DmsDragDropDialog } from './dmsdragdrop/dmsdragdrop.dialog';
import { VhcCross_sellModule } from 'src/app/vhcmodules/cross_sellmodule/cross_sellmodule';
import { DmsItemsPairDialog, dmsvhccombi } from './itemspair/dmsitemspair.dialog';

@Component({
  selector: 'app-jobpartscreen',
  templateUrl: './jobpartscreen.dialog.html',
  styleUrls: ['./jobpartscreen.dialog.scss'],
})
export class JobPartscreenDialog implements OnInit {

  @Input('title') title: Vhcmodule[]
  @Input('completed') completed: string
  @Input('modules') modules: Vhcmodule[]
  @Input('vhcrecord') vhcrecord: any
  @Input('vehicle') vehicle: any
  @Input('ispre') ispre = false
  @Input('ignorePartsDMSImport') ignorePartsDMSImport: string[] = []

  settings: JSettings = undefined
  exconf: any = undefined

  constructor(private modalController: ModalController, private helper: HelperService, private supa: SupaService, private loadingController: LoadingController, private dms:DmsService) {
  }

  getModules(forDms=false) {
    return this.modules.filter((module:Vhcmodule) => {
      if (module.type == 'Questionblock') {
        return (module as VhcQuestionblockModule).questions.findIndex(v => v.value == 2 || v.value == 1 || v.dateAuthorised) >= 0
      } else if (module.type == 'Tyres') {
        return (module as VhcTyreModule).data.tyres.findIndex(v => v.value == 2 || v.value == 1 || v.dateAuthorised) >= 0
      } else if (module.type == 'Brakes') {
        return (module as VhcBrakeModule).data.brakes.findIndex(v => v.value == 2 || v.value == 1 || v.dateAuthorised) >= 0
      } else if (module.type == 'Cross_sell' && !forDms) {
        return (module as VhcCross_sellModule).data.length > 0
      } else {
        return false
      }
    });
  }

  sanitiseItem(item) {
    if (!item.jobs) {
      item.jobs = []
    }
    if (!item.parts) {
      item.parts = []
    }
    if (!item.sundries) {
      item.sundries = 0
    }
  }

  calculatePrice(item) {
    this.sanitiseItem(item)
    item.price = Number.parseFloat('' + item.sundries) + Number.parseFloat(item.parts.map(p => p.price).reduce((a, b) => a + b, 0)) + Number.parseFloat(item.jobs.map(j => j.price).reduce((a, b) => a + b, 0));
  }

  public static ConvertToItems(modules): DmsTask[] {
    let repairitems: DmsTask[] = [];
    modules.forEach(m => {
      if (m.type == 'Questionblock') {
        m.questions.forEach(q => {
          if (q.value == 2 || q.value == 1 || q.dateAuthorised) {
            repairitems.push({ "ItemName": q.name, "Remarks1": q.recommendation, "Remarks2": q.recommendation2, "Color": q.value == 1 ? 'red' : 'amber', "ItemID": q.portalid })
          }
        })
      } else if (m.type == 'Tyres') {
        m.data.tyres.forEach(t => {
          if (t.value == 2 || t.value == 1 || t.dateAuthorised) {
            repairitems.push({ "ItemName": 'Tyre, ' + (t.name + ' -> ' + t.size + ' ' + t.loadindex), "Remarks1": t.recommendation, "Remarks2": t.recommendation2, "Color": t.value == 1 ? 'red' : 'amber', "ItemID": t.portalid })
          }
        })
      } else if (m.type == 'Brakes') {
        m.data.brakes.forEach(t => {
          if (t.value == 2 || t.value == 1 || t.dateAuthorised) {
            repairitems.push({ "ItemName": 'Brake, ' + t.name, "Remarks1": t.recommendation, "Remarks2": t.recommendation2, "Color": t.value == 1 ? 'red' : 'amber', "ItemID": t.portalid })
          }
        })
      } else if (m.type == 'Cross_sell') {
        m.data.forEach(t => {
          if (t.value == 2 || t.value == 1 || t.dateAuthorised) {
            repairitems.push({ "ItemName": t.name, "Remarks1": "", "Remarks2": "", "Color": 'amber', "ItemID": t.portalid })
          }
        })
      }
    // eslint-disable-next-line @typescript-eslint/semi
    })
    return repairitems.map(r => {r.parts = []; return r;});
  }

  async updateRecord(update_data) {
    // Loading modal
    const loading = await this.loadingController.create({
      message: 'Uploading the vhc record to the database, one moment please',
      spinner: 'bubbles'
    });
    await loading.present();
    // Upload the data and return the result.
    let { data, error } = await this.supa.supabase.from('vhc_vhcrecord').update(update_data).eq('id', this.vhcrecord.id)
    if (error) {
      this.helper.notify('Could not upload data', 'danger');
      loading.dismiss();
      return false;
    } else {
      this.helper.notify('Data was uploaded', 'success');
      loading.dismiss();
      return true;
    }
  }

  filteredTyres(tyres) {
    return tyres.filter(v => v.value == 2 || v.value == 1 || v.dateAuthorised)
  }

  filteredBrakes(brakes) {
    return brakes.filter(v => v.value == 2 || v.value == 1 || v.dateAuthorised)
  }

  ngOnInit() {
    this.loadSettings();
  }

  async loadSettings() {
    this.settings = await this.supa.Settings();
    this.exconf = await this.supa.ExternalConfig();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  saveModal() {
    this.modalController.dismiss({savedata: true});
  }

  complete() {
    this.helper.promptYesNo('Do you want to complete "' + this.title + '"?', 'The step will be finished and the next step will unlock.', ()=>{
      this.modalController.dismiss({completestep: true});
    }, 'Complete step', 'Cancel')
  }

}

export interface ReqTask {
  jm_master_job_no: string;
  ji_job_no: string;
  concern_id: string;
  concern_desc: string;
  ji_srl_no: string;
  ji_operation_id: string;
  ji_operation_descr: string;
  ara_ji_operation_descr: string;
  labor_price?: any;
  std_time: number;
  iq_concern_id?: string;
  est_approved: string;
}

export interface ReqPart {
  jm_master_job_no: string; // Master job card number.
  job_no: string;           // Job card number.
  parts_req_id: number;     // parts request id.
  concern_id: string;       // job card concern id.
  sr_no: number;            // serial number.
  jr_req_part: string;      // Part Name.
  requested_qty: number;    // Requested Qty.
  quote_qty: number;        // Quoted Qty.
  net_amount: number;       // Part Amount.
  est_approved: string;     // Approval Flag.
  qt_part?: string;
  iq_concern_id?: string;
}
